import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { downloadFiles } from 'src/app/shared/utils';
import { NDAStatusLabel, KYCStatus } from 'src/app/shared/constants/constants';
import { CustomerdialogComponent } from '../customerdialog/customerdialog.component';
import { TermsConditionComponent } from '../terms-condition/terms-condition.component';
import { TermsConditionLegalDialogComponent } from '../terms-condition-legal-dialog/terms-condition-legal-dialog.component';
import { PaymentTermsDialogComponent } from '../payment-terms-dialog/payment-terms-dialog.component';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { InterestUpdateDialogComponent } from '../interest-update-dialog/interest-update-dialog.component';
import { IndustryUpdateDialogComponent } from '../industry-update-dialog/industry-update-dialog.component';
import { ProfileService } from '../profile.service';

interface Name {
  firstName: string;
  lastName: string;
  title: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  // show tabs
  financeTab: boolean = false;
  companyTab: boolean = false;
  kycTab: boolean = false;
  tncTab: boolean = false;

  @ViewChild('profileTabs') profileTabs: any;
  public loading = false;
  primaryColour = '#DA2128';
  secondaryColour = '#DA2128';

  interestData: any[] = [];
  industryData: any[] = [];
  interestsList: any = [];
  industryList: any = [];
  // finalProfileScoreInPercent = 10;
  name: Name = {
    firstName: '',
    lastName: '',
    title: '',
  };
  profileInfo: any;
  leftPanelInfo: any;
  userid: string = '';
  isActivenonDisclosureAgreement!: boolean;
  isActiveLegalTermsCondition!: boolean;
  isActivePaymentTerms!: boolean;
  baseUrl = environment.BASE_URL;
  documentInfo = {
    userType: 'Customer',
    documentUseFor: 'cheque',
    baseUrl: this.baseUrl,
  };
  regionsList: any[] = [];
  manPowerList: any[] = [];
  revenueList: any[] = [];
  regionWiseCountriesList: Map<string, any> = new Map();
  manPowerMap: Map<number, any> = new Map();
  revenueMap: Map<number, any> = new Map();
  categoriesMap: Map<number, any> = new Map();
  regions: any[] = [];
  kycData: any;
  showBusinessOthers: boolean = false;

  rightPanelActive: boolean = false;

  NDAStatusLabel: any = NDAStatusLabel;
  ndaStatus: string = '';
  customerData: any;
  user!: any;

  KYCStatus: any = KYCStatus;
  statusKycHeading: string = '';
  statusKycText: string = '';
  statusKycIcon: string = 'timer';
  activeIndex: number = 1;
  kycDetails = [
    {
      key: 'KD_AUTHRISE_ID',
      title: 'PAN No./Identification documents of authorised signatories/directors/owners',
    },
    // {
    //   key: 'KD_OWNER_ID',
    //   title: 'For sole proprietors or individuals: Identification documents of the owner',
    // },
    {
      key: 'KD_TAX_CERTIFICATION',
      title: 'Tax Registration Certificates',
    },
    {
      key: 'KD_PERMITS',
      title: 'Business License or Permits (if applicable)',
    },
  ];
  registeredAddress = [
    {
      key: 'RA_REGISTRATION_CERTIFICATES',
      title: 'Certificate of Incorporation/Business Registration Certificate',
    },
    {
      key: 'RA_UTILITY_BILLS',
      title: 'Recent utility bills',
    },
    {
      key: 'RA_OWNERSHIP_DOC',
      title: 'Lease agreement or property ownership docs',
    },
  ];
  correspondenceAddress = [
    {
      key: 'CA_REGISTRATION_CERTIFICATES',
      title: 'Certificate of Incorporation/Business Registration Certificate',
    },
    {
      key: 'CA_UTILITY_BILLS',
      title: 'Recent utility bills',
    },
    {
      key: 'CA_OWNERSHIP_DOC',
      title: 'Lease agreement or property ownership docs',
    },
  ];
  financeDetails = [
    {
      key: 'FB_BANK_STATEMENT',
      title:
        'Bank statements or proof of banking relationship for last 1 year (signed by bank)',
    },
    {
      key: 'FB_FINANCIAL_STATEMENT',
      title:
        'Financial statements (balance sheets, profit and loss statements) for the last 1 year',
    },
    {
      key: 'FB_TAX_RETURN',
      title: 'Tax returns for the last 1 year',
    },
    {
      key: 'FB_GENERAL_LIABILITY',
      title: 'General liability insurance certificates',
    },
    {
      key: 'FB_PRODUCT_LIABILITY',
      title: 'Product liability insurance certificates(if applicable)',
    },
  ];
  cancelCheque = {
    key: 'CANCEL_CHEQUE',
  };
  constructor(
    private profileData: CommonService,
    public dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.userid = sessionStorage.getItem('customeruserId') || '';
  }

  private docusignFlowAfterCompletion() {
    const envelopeId = this.activatedRoute.snapshot.queryParamMap.get('envelopeId') || '';
    const event = this.activatedRoute.snapshot.queryParamMap.get('event');
    let hasCustomerSigned = true;

    const refreshPage = () =>
      this.router.navigateByUrl('/profile', { replaceUrl: true });

    if (event === 'signing_complete') {
      this.submitNda(event, envelopeId, hasCustomerSigned);
    }

    if (event) refreshPage();
  }

  submitNda(docusignStatus: string, envelopeId: string, hasCustomerSigned: boolean) {
    // let dataItem: any = first(this.uploadedDocumentInfo?.attachment);
    const payload = {
      userId: this.userid,
      ndaStatus: null,
      adminComment: '',
      fileStatus: null,
      docusignStatus: docusignStatus,
      envelopeId: envelopeId,
      adminSigned: false,
      customerSigned: hasCustomerSigned,
    };
    const apiURL = `${this.baseUrl}customer/nda/save`;
    this.commonService.postDatawithoutHeaders(apiURL, payload).subscribe({
      next: (res: any) => {
        this.toastr.success('NDA Uploaded successfully');
        document.body.classList.remove('rfqboxOpen');
        this.leftPanelData();
        this.getProfileData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }

  downloadBrochureFile(brochureFileId: number, fileName: string): void {
    let apiUrl: string = `${this.baseUrl}customer/document-management/customerDocumentDownload?docId=${brochureFileId}`;
    this.profileData.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
      },
      error: (error) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }
  getProfileData() {
    let apiUrl: any = `${this.baseUrl}customer/profile?userId=${this.userid}&forCustomer=true`;
    this.profileData.getData(apiUrl).subscribe((data) => {
      this.profileInfo = data;
      this.isActivenonDisclosureAgreement =
        data.response?.termsAndConditions?.nonDisclosureAgreement;
      this.isActiveLegalTermsCondition =
        data.response?.termsAndConditions?.legalTermsCondition;
      this.isActivePaymentTerms = data.response?.termsAndConditions?.paymentTerms;
      this.regions = data?.response?.customerCompanyProfile?.regionWisePresences;
      this.getInterest(data.response.customerCompanyProfile.interests);
      this.getIndustry(data.response.customerCompanyProfile.industries);
      setTimeout(() => {
        if (this.profileService.kycUpdated) {
          this.profileTabs.selectedIndex = 3;
        }
      }, 500);
    });
  }
  leftPanelData() {
    let apiURL: any = `${this.baseUrl}customer/user-profile/getUserProfileCustomer?userId=${this.userid}`;
    this.profileData.getData(apiURL).subscribe((data: any) => {
      this.user = {
        name: data.response.name,
        email: data.response.email,
      };
      this.leftPanelInfo = data;
      this.name.firstName = data.response.firstName;
      this.name.lastName = data.response.lastName;
      const name = this.name.firstName?.split(' ') + ' ' + this.name.lastName?.split(' ');
      // sessionStorage.setItem('customerUserName', `${this.name.firstName} ${this.name.lastName}`);
      sessionStorage.setItem('customerUserName', name);
      this.name.title = data.response.title;

      this.financeTab = data?.response?.financeTab;
      this.companyTab = data?.response?.companyTab;
      this.kycTab = data?.response?.kycTab;
      this.tncTab = data?.response?.tncTab;
    });
  }
  ngOnInit() {
    this.docusignFlowAfterCompletion();
    this.getProfileData();
    this.leftPanelData();
    // this.route.params.subscribe(()=>{
    //   this.getProfileData();
    // });

    this.getRegionsList();
    this.getManPowerList();
    this.getRevenueList();
    this.getCategoriesList();
    this.getkycData();
  }

  fileUploadEvent(fileUploadEvent: any) {
    //  console.log(fileUploadEvent);
  }

  getRegionName(region: any): string {
    if (this.regionWiseCountriesList) {
      return this.regionWiseCountriesList.get(region)?.regionWisePresenceName;
    }
    return '';
  }

  getRegionCountry(region: any, countryId: number): string {
    let country;
    if (this.regionWiseCountriesList) {
      const countries = this.regionWiseCountriesList.get(region)?.countries;
      country = countries?.find((country: any) => country.id === countryId);
      country = country?.countryName;
    }
    return country;
  }

  getRevenueName(revenueId: number): string {
    if (this.revenueMap.has(revenueId)) {
      return this.revenueMap.get(revenueId);
    }
    return '';
  }

  getCategoryName(categories: string): string[] {
    const categoryIds: number[] = JSON.parse(categories);
    let categoriesNames: string[] = [];
    categoryIds?.forEach((category) => {
      if (this.categoriesMap.has(category)) {
        categoriesNames.push(this.categoriesMap.get(category));
      }
    });
    return categoriesNames;
  }

  getRegionsList() {
    let apiURL = `${this.baseUrl}common-service/region-wise`;
    this.profileData.getData(apiURL).subscribe({
      next: (res: any) => {
        this.regionsList = res.response;
        this.regionsList.forEach((region) => {
          this.regionWiseCountriesList.set(region.regionWisePresenceId, {
            countries: region.countries,
            regionWisePresenceName: region.regionWisePresenceName,
          });
        });
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  getManPowerList() {
    let apiURL = `${this.baseUrl}common-service/company-size`;
    this.profileData.getData(apiURL).subscribe({
      next: (res: any) => {
        this.manPowerList = res.response;
        this.manPowerList.forEach((manPower) => {
          this.manPowerMap.set(manPower.companySizeId, manPower.companySizeName);
        });
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  getRevenueList() {
    let apiURL = `${this.baseUrl}common-service/turnover`;
    this.profileData.getData(apiURL).subscribe({
      next: (res: any) => {
        this.revenueList = res.response;
        this.revenueList.forEach((revenue) => {
          this.revenueMap.set(revenue.turnoverId, revenue.turnoverRange);
        });
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  getCategoriesList() {
    this.profileData
      .getData(`${this.baseUrl}common-service/category-management`)
      .subscribe({
        next: (res: any) => {
          const categories: any = res.response;
          categories.forEach((category: any) => {
            this.categoriesMap.set(category.id, category.categoryName);
          });
        },
        error: (e) => {
          this.toastr.error(e.error.status.error.message);
        },
      });
  }

  openDialog(): void {
    this.dialog
      .open(CustomerdialogComponent, {
        width: '500px',
        panelClass: 'custom-modalbox-500',
        position: { right: '30%' },
      })
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => {
          if (isTrue) {
            this.router.navigateByUrl('/profile-update');
          }
        },
      });
  }
  getName(): string {
    const name = this.name.firstName?.split(' ') + ' ' + this.name.lastName?.split(' ');
    return name
      ?.split(' ')
      .map((n) => n[0])
      .join('')
      ?.toUpperCase();
  }
  getTermsAndConditions() {
    const config = new MatDialogConfig();
    config.data = {
      isActivenonDisclosureAgreement: this.isActivenonDisclosureAgreement,
    };
    const dialogRef = this.dialog
      .open(TermsConditionComponent, config)
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => {
          if (isTrue) {
            const payload = {
              userId: this.userid,
              nonDisclosureAgreement: true,
            };
            const apiUrl = `${this.baseUrl}customer/lead-management/updateTermsAndCondition/`;
            const userIdWithQueryString = `${this.userid}?forCustomer=true`;

            this.profileData.update(apiUrl, userIdWithQueryString, payload).subscribe({
              next: (res: any) => {
                this.getProfileData();
              },
            });
          }
        },
      });
  }

  getLegalTermsAndConditions() {
    const config = new MatDialogConfig();
    config.data = {
      isActiveLegalTermsCondition: this.isActiveLegalTermsCondition,
    };
    const dialogRef = this.dialog
      .open(TermsConditionLegalDialogComponent, config)
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => {
          if (isTrue) {
            const payload = {
              userId: this.userid,
              legalTermsCondition: true,
            };
            const apiUrl = `${this.baseUrl}customer/lead-management/updateTermsAndCondition/`;
            this.profileData.update(apiUrl, this.userid, payload).subscribe({
              next: (res: any) => {
                this.getProfileData();
              },
            });
          }
        },
      });
  }

  getPaymentTermsAndConditions() {
    // alert("PaymentTermsDialogComponent");
    const config = new MatDialogConfig();
    config.data = {
      isActivePaymentTerms: this.isActivePaymentTerms,
    };
    const dialogRef = this.dialog
      .open(PaymentTermsDialogComponent, config)
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => {
          if (isTrue) {
            const payload = {
              userId: this.userid,
              paymentTerms: true,
            };
            const apiUrl = `${this.baseUrl}customer/lead-management/updateTermsAndCondition/`;
            this.profileData.update(apiUrl, this.userid, payload).subscribe({
              next: (res: any) => {
                this.getProfileData();
              },
            });
          }
        },
      });
  }
  getInterest(data: any[]) {
    let apiUrl = `${this.baseUrl}common-service/interest-management`;
    this.profileData.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.interestsList = res.response;
        this.interestsList = this.interestsList.map((interest: any) => {
          let tempId = interest.id;
          interest.interestId = tempId;
          interest.id = null;
          interest.interestValues = interest.interestValues.map((values: any) => {
            values['isChecked'] = false;
            if (data && data.length > 0) {
              data.forEach((interestCheckedData) => {
                if (
                  interest.interestId == interestCheckedData.interestId &&
                  JSON.parse(interestCheckedData.interestValues).indexOf(values.id) > -1
                ) {
                  interest.id = interestCheckedData.id;
                  values['isChecked'] = true;
                }
              });
            } else {
              values['isChecked'] = false;
            }

            return values;
          });
          return interest;
        });
        this.setInterest(this.interestsList);
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setInterest(data: any) {
    this.interestsList = JSON.parse(JSON.stringify(data));
    this.interestData = [];

    this.interestsList.forEach((interest: any) => {
      let interestValues: any[] = [];
      interest.interestValues.forEach((values: any) => {
        if (values.isChecked) {
          interestValues.push(values.id);
        }
      });
      if (interestValues.length > 0) {
        this.interestData.push({
          interestId: interest.interestId,
          id: interest.id,
          name: interest.name,
          interestValues: interestValues,
        });
      }
    });
  }
  openInterestDialog(): void {
    this.dialog
      .open(InterestUpdateDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.interestsList)),
          editable: false,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            //this.setInterest(res.data);
          }
        },
      });
  }
  getIndustry(data: any[]) {
    let apiUrl = `${this.baseUrl}common-service/industry-management`;
    this.profileData.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.industryList = res.response;
        this.industryList = this.industryList.map((industry: any) => {
          let tempId = industry.id;
          industry.industryId = tempId;
          industry.id = null;
          industry.sectors = industry.sectors.map((sector: any) => {
            sector['isChecked'] = false;
            if (data && data.length > 0) {
              data.forEach((interestCheckedData) => {
                if (
                  industry.industryId == interestCheckedData.industryId &&
                  JSON.parse(interestCheckedData.sectors).indexOf(sector.sectorId) > -1
                ) {
                  industry.id = interestCheckedData.id;
                  sector['isChecked'] = true;
                }
              });
            } else {
              sector['isChecked'] = false;
            }

            return sector;
          });
          return industry;
        });
        this.setIndustry(this.industryList);
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setIndustry(data: any) {
    this.industryList = JSON.parse(JSON.stringify(data));
    this.industryData = [];

    this.industryList.forEach((industry: any) => {
      let sectors: any[] = [];
      industry.sectors.forEach((sector: any) => {
        if (sector.isChecked) {
          sectors.push(sector.sectorId);
        }
      });
      if (sectors.length > 0) {
        this.industryData.push({
          industryId: industry.industryId,
          id: industry.id,
          industryName: industry.industryName,
          sectors: sectors,
        });
      }
    });
  }
  openIndustryDialog(): void {
    this.dialog
      .open(IndustryUpdateDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.industryList)),
          editable: false,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            //this.setInterest(res.data);
          }
        },
      });
  }

  getkycData() {
    let customerId = sessionStorage.getItem('customercompanyId') || '';
    let apiUrl = `${this.baseUrl}customer/customer-kyc-details/get-kyc-details/${customerId}`;
    this.profileData.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.kycData = res?.response;
        this.getKycText(this.kycData.status);
        this.showBusinessOthers =
          this.kycData?.categoryOfBusiness?.toLowerCase() == 'others' ? true : false;
      },
      error: (e) => {
        if (e?.error?.status?.error?.message)
          this.toastr.error(e?.error?.status?.error?.message);
      },
    });
  }

  downloadKycFile(id: number, fileName: string): void {
    downloadFiles(this.baseUrl, this.profileData, this.toastr, id, fileName);
  }
  openNdaDisclosuer(ndaStatus: string, event?: any) {
    document.body.classList.add('rfqboxOpen');
    this.rightPanelActive = !this.rightPanelActive;
    this.customerData = {
      statusItem: ndaStatus,
      customerId: this.leftPanelInfo?.response?.userId,
    };
  }
  closeDisclosuer(event: any) {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
  }
  onChildClose() {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
  }
  onUpdateNda() {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
    this.getProfileData();
  }
  getNDALabel(ndaLabel: string) {
    let label;
    if (ndaLabel == 'IN_REVIEW') {
      label = 'In Review';
    } else if (ndaLabel == 'APPROVED') {
      label = 'Accepted';
    } else {
      label = this.NDAStatusLabel[ndaLabel];
    }
    return label;
  }
  isExistItem(fileKey: string): boolean {
    return (
      this.kycData?.kycFiles?.some((fileItem: any) => fileItem.useFor === fileKey) ||
      false
    );
  }

  getKycText(status: string) {
    switch (status) {
      case KYCStatus.PENDING:
        this.statusKycIcon = 'circle-alert';
        this.statusKycHeading = 'KYC Pending';
        this.statusKycText =
          'Your KYC verification process is currently pending. To ensure that we can complete your registration and continue with our business relationship, please provide any outstanding documentation or information requested';
        break;
      case KYCStatus.BD_RETURNED:
      case KYCStatus.RETURNED:
        this.statusKycIcon = 'triangle-alert';
        this.statusKycHeading = 'KYC Returned';
        this.statusKycText = this.kycData.faremarks || this.kycData.bdremarks;
        break;
      case KYCStatus.AWAITING_APPROVAL:
      case KYCStatus.IN_REVIEW:
        this.statusKycIcon = 'timer';
        this.statusKycHeading = 'Awaiting Approval';
        this.statusKycText =
          'Your KYC verification is currently under review. We will notify you once the process is complete.';
        break;
      case KYCStatus.APPROVED:
        this.statusKycIcon = 'codesandbox';
        this.statusKycHeading = 'KYC Approved';
        this.statusKycText =
          'Congratulations! Your KYC verification has been approved. You are now fully registered with us.';
        break;
    }
  }
  toggleAccordion(index: number) {
    this.activeIndex = index === this.activeIndex ? -1 : index;
  }
}
